import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const RoomRowContainer = styled(Grid)(() => ({
  padding: "12px 16px",
}));

export const RoomItemsInfo = styled("ul")(() => ({
  listStyle: "none",
  margin: 0,
  display: "flex",
  alignItems: "center",
  "& li": {
    margin: 0,
    position: "relative",
    "&:not(:last-child)": {
      paddingRight: "12px",
      marginRight: "12px",
      "&:after": {
        content: "''",
        position: "absolute",
        top: 0,
        right: 0,
        width: 1,
        height: "100%",
        backgroundColor: colors.gray200,
      },
    },
  },
}));

export const RoomInfoText = styled("span")(() => ({
  font: "600 14px Manrope",
  lineHeight: "20px",
  letterSpacing: "0.1px",
  color: colors.gray600,
}));
